import type { DisplayMode, IncidentCategory, IncidentComplexity, MeasurementType } from '@/types/api/Masterdata'

import ky, { cacheHook } from './httpService'

export async function getCategories() {
  return await ky.get('api/IncidentCategory', { hooks: cacheHook() }).json<IncidentCategory[]>()
}
export async function getComplexity() {
  return await ky.get('api/IncidentComplexity', { hooks: cacheHook() }).json<IncidentComplexity[]>()
}
export async function getDisplayModes() {
  return await ky.get('api/DisplayMode', { hooks: cacheHook() }).json<DisplayMode[]>()
}
export async function getMeassurements() {
  return await ky.get('api/IncidentMeasurementType', { hooks: cacheHook() }).json<MeasurementType[]>()
}
